<template>
  <b-container
    class="bv-example-row"
    fluid
  >
    <b-row align-h="end">
      <b-button
        variant="success"
        @click="openFieldModal"
      >
        เพิ่มข้อมูล
      </b-button>
    </b-row>
    <b-row style="padding-top: 2rem;">
      <b-table
        responsive
        striped
        hover
        bordered
        :fields="fields"
        :items="items"
      >
        <template
          slot="id"
          slot-scope="data"
        >
          <div class="col-right">
            {{ data.item.id }}
          </div>
        </template>
        <template
          slot="account_name"
          slot-scope="data"
        >
          <div class="col-left">
            {{ data.item.account_name }}
          </div>
        </template>
        <template
          slot="bank_name"
          slot-scope="data"
        >
          <div class="col-left">
            {{ data.item.bank_name }}
          </div>
        </template>
        <template
          slot="branch_name"
          slot-scope="data"
        >
          <div class="col-left">
            {{ data.item.bank_name }}
          </div>
        </template>
        <template
          slot="corporation.name"
          slot-scope="data"
        >
          <div class="col-left">
            {{ data.item.corporation.name }}
          </div>
        </template>
        <template
          slot="action"
          slot-scope="data"
        >
          <b-container fluid>
            <b-row>
              <b-col>
                <b-button
                  variant="warning"
                  @click="openFieldModal(data.item.id)"
                >
                  แก้ไข
                </b-button>
              </b-col>
              <b-col>
                <b-button
                  variant="danger"
                  @click="openDeleteModal(data.item.id)"
                >
                  ลบ
                </b-button>
              </b-col>
            </b-row>
          </b-container>
        </template>
      </b-table>
    </b-row>
    <sweet-modal ref="inputModal">
      <input-modal :fields.sync="inputFields" />
      <b-row>
        <b-col cols="auto">
          <b-button
            variant="success"
            @click="submit"
          >
            บันทึก
          </b-button>
        </b-col>
        <b-col cols="auto">
          <b-button
            @click="$refs['inputModal'].close()"
          >
            ยกเลิก
          </b-button>
        </b-col>
      </b-row>
    </sweet-modal>
    <b-modal
      ref="confirmDelete"
      title="ยืนยันการลบ"
      ok-title="ยืนยัน"
      cancel-title="ยกเลิก"
      @ok="delBreed"
    >
      <confirm-modal />
    </b-modal>
  </b-container>
</template>

<script>
  import {mapActions, mapGetters} from "vuex"
  import InputModal from "../../components/Settings/InputModal"
  import ConfirmModal from "../../components/Settings/ConfirmModal"

  export default {
    name: "Breed",
    components: {
      InputModal,
      ConfirmModal
    },
    data() {
      return {
        fields: [
          {
            key: 'id',
            label: 'ID',
            isInputField: false,
          },
          {
            key: 'corporation.name',
            label: 'สาขา',
            isInputField: true,
            isSpecialField: false,
            fieldType: 'text'
          },
          {
            key: 'bank_name',
            label: 'ธนาคาร',
            isInputField: true,
            isSpecialField: false,
            fieldType: 'text'
          },
          {
            key: 'account_name',
            label: 'ชื่อ',
            isInputField: false,
          },
          {
            key: 'bank_branch',
            label: 'สาขาธนาคาร',
            isInputField: false,
          },
          {
            key: 'account_number',
            label: 'เลขที่บัญชี',
            isInputField: false,
          }
        ],
        inputFields: [
          {
            key: 'corporation_id',
            label: 'Corporation',
            fieldType: 'selected',
            textField: 'name',
            valueField: 'value',
            resources: []
          },
          {
            key: 'bank_name',
            label: 'ชื่อธนาคาร',
            fieldType: 'text',
            value: '',
            required: true,
            default: ''
          },
          {
            key: 'account_name',
            label: 'ชื่อบัญชี',
            fieldType: 'text',
            value: '',
            required: true,
            default: ''
          },
          {
            key: 'account_number',
            label: 'เลขที่บัญชี',
            fieldType: 'text',
            value: '',
            required: true,
            default: ''
          },
          {
            key: 'bank_branch',
            label: 'ชื่อสาขาธนาคาร',
            fieldType: 'text',
            value: '',
            required: true,
            default: ''
          },
        ],
        items: [],
        itemSelected: null,
        modalTitle: "",
        deleteAccountIdSelected: null,
        password: '',
      }
    },
    computed: {
      ...mapGetters({
        getPlatforms: "Account/getPlatforms"
      })
    },
    methods: {
      ...mapActions({
        getCorporationAccounts: "Corporation/getCorporationAccounts",
        setPlatforms: "Account/setPlatforms",
        updateAccount: "Corporation/updateCorporationAccount",
        createAccount: "Corporation/createCorporationAccount",
        deleteAccount: "Corporation/deleteCorporationAccount"
      }),
      async openFieldModal(breedId = null) {
        this.itemSelected = this.items.find((item) => {
          return item.id === breedId;
        }) || null;

        this.clearInputField()

        this.$refs['inputModal'].open();
      },
      async openDeleteModal(breedId) {
        this.deleteAccountIdSelected = breedId
        const { value: password } = await this.$swal.fire({
          title: 'กรอกรหัสผ่านเพื่อดำเนินการต่อไป',
          input: 'password',
          inputAttributes: {
            autocapitalize: 'off',
            autocorrect: 'off'
          }
        })

        if (password) {
          this.password = password
          this.delAccount()
        } else {
          this.password = ''
          return
        }
        // this.$refs['confirmDelete'].show();
      },
      async submit() {
        let payload = {}
        let malformedCheck = false
        this.inputFields.forEach(el => {
          if (el.value === null || el.value === '' || el.value === undefined) {
            if (!el.required) {
              payload[el.key] = el.default
            } else {
              malformedCheck = true
              this.$swal.fire('กรอกข้อมูลไม่ครบ')
            }
          } else {
            payload[el.key] = el.value;
          }
        })

        if (malformedCheck) {
          return;
        }

        this.$refs['inputModal'].close()

        const { value: password } = await this.$swal.fire({
          title: 'กรอกรหัสผ่านเพื่อดำเนินการต่อไป',
          input: 'password',
          inputAttributes: {
            autocapitalize: 'off',
            autocorrect: 'off'
          }
        })

        if (password) {
          this.password = password
        } else {
          this.password = ''
          this.$refs['inputModal'].open()
          return
        }

        this.$store.state.isLoading = true

        let corporationArray = payload.corporation_id.split('||')
        payload.corporation_id = corporationArray[0]
        payload.corporation_type = corporationArray[1]

        if (this.itemSelected) {
          try {
            var res = await this.updateAccount({
              payload,
              id: this.itemSelected.id,
              password: this.password
            });
          } catch (e) {
            this.password = ''
            this.$swal.fire('เกิดข้อผิดพลาด', e.message, 'error')
            this.$store.state.isLoading = false
            return
          }

        } else {
          try {
            var res = await this.createAccount({ ...payload, password: this.password });
          } catch (e) {
            this.password = ''
            this.$swal.fire('เกิดข้อผิดพลาด', e.message, 'error')
            this.$store.state.isLoading = false
            return
          }
        }

        try {
          this.items = await this.getCorporationAccounts()
        }  catch (e) {
          this.password = ''
          this.$swal.fire('เกิดข้อผิดพลาด', e.message, 'error')
          this.$store.state.isLoading = false
          return
        }
        this.$refs['inputModal'].close()
        this.itemSelected = null
        this.password = ''
        await this.$swal.fire("บันทึกเสร็จสิ้น")
        this.$store.state.isLoading = false
      },
      clearInputField() {
        if (this.itemSelected) {
          this.inputFields.forEach(el => {
            el.value = this.itemSelected[el.key]
          })
        } else {
          this.inputFields.forEach(el => {
            el.value = ''
          })
        }
        this.modalTitle = this.itemSelected ? 'แก้ไขข้อมูล' : 'เพิ่มข้อมูล';
      },
      async delAccount() {
        this.$store.state.isLoading = true
        try {
          let res = await this.deleteAccount({ id: this.deleteAccountIdSelected, password: this.password })
        } catch (e) {
          this.password = ''
          this.$swal.fire('เกิดข้อผิดพลาด', e.message, 'error')
          this.$store.state.isLoading = false
          return
        }
        this.deleteAccountIdSelected = null

        try {
          this.items = await this.getCorporationAccounts()
        } catch (e) {
          this.password = ''
          this.$swal.fire('เกิดข้อผิดพลาด', e.message, 'error')
          this.$store.state.isLoading = false
          return
        }
        await this.$swal.fire('ลบข้อมูลเสร็จสิ้น')
        this.$store.state.isLoading = false
        this.password = ''
        // this.$refs['confirmDelete'].hide();
      }
    },
    async mounted() {
      await this.setPlatforms()
      let corporationInputIndex = this.inputFields.findIndex(input => input.key === 'corporation_id')
      if (corporationInputIndex >= 0) {
        this.inputFields[corporationInputIndex].resources = await this.getPlatforms.map(platform => ({ ...platform, value: `${platform.id}||${platform.platform_type}`}))
      }
      this.items = await this.getCorporationAccounts()
    }
  }
</script>

<style scoped>

</style>
